"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationService = void 0;
const api_1 = require("./api");
const PATH = '/uaa/api';
const PROFILE_PATH = '/profile/api';
class RegistrationService {
    static async register(registrationData, lotteryId) {
        try {
            return await api_1.API.post({
                url: `${PATH}/player/create`,
                body: registrationData.getPostRequest(lotteryId)
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async registerV2(registrationData, lotteryId) {
        try {
            return await api_1.API.post({
                url: `${PROFILE_PATH}/v2/profiles/register-with-recaptcha`,
                body: registrationData.getPostRequest(lotteryId)
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async checkEmail(email) {
        try {
            return await api_1.API.get({
                url: `${PATH}/player/check-email?emailAddress=${encodeURIComponent(email)}`
            });
        }
        catch (e) {
            return e;
        }
    }
    static async checkInviteCode(inviteCode) {
        try {
            return await api_1.API.get({
                url: `${PROFILE_PATH}/additional-infos/checkInviteCode?referralCodeData=${inviteCode}`
            });
        }
        catch (e) {
            return e;
        }
    }
}
exports.RegistrationService = RegistrationService;
//# sourceMappingURL=registration-service.js.map